import axiosPrivate from "./axiosPrivate";

export const getMemorandum = (mes) => {
  return axiosPrivate.post("getMemorandum", { mes });
};

export const insertMemorandum = (data) => {
  return axiosPrivate.post("insertMemorandum", data);
};

export const updateMemorandum = (data) => {
  return axiosPrivate.post("updateMemorandum", data);
};

export const deleteMemorandum = (memorandum_id) => {
  return axiosPrivate.post("deleteMemorandum", { memorandum_id });
};
